import axios from 'axios'

const API = axios.create({
  baseURL: 'https://game-shift-email-server.vercel.app',
})

export const sendEmail = (formData) => API.post('/send-email', formData)
